import Router from 'next/router';

import { Navigation } from './site-settings';

export const calculatePercentage = (total: number, value: number) =>
  parseFloat(((value / total) * 100).toFixed());

export const isThirdElem = (index: number) => index % 3 === 0;

export function isMacintosh() {
  return navigator.platform.indexOf('Mac') > -1;
}

export function parseJwt(token: string) {
  if (token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64));
  }
  return token;
}

export function isAuthenticated(token: string): boolean {
  try {
    const jwtPayload = parseJwt(token);
    if (jwtPayload) {
      // return jwtPayload.exp > +new Date() / 1000;
      return !!jwtPayload;
    }
  } catch (e) {
    // console.log(e);
  }
  return false;
}

export const isSSR = () => typeof window === 'undefined';

export const validateEmail = (text: string) => {
  const emailPattern =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailPattern.test(text);
};

export const validateUrl = (string: string) => {
  let url: URL;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === 'http:' || url.protocol === 'https:';
};

export function deleteAllCookies() {
  const cookies = document.cookie.split(';');

  for (const cookie of cookies) {
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
  }
}

export const getRandomArrayElement = (array: any[]) =>
  array[Math.floor(Math.random() * array.length)];

export const logoutUser = (): void => {
  deleteAllCookies();
  setTimeout(() => {
    Router.push(Navigation.Signin.href);
  }, 300);
};
